<template lang="pug">
  v-content
    v-layout(text-center wrap)
      v-flex(xs12)
        v-img(
          :src="require('@/assets/nouhinsyo.svg')"
          class="my-3"
          contain
          height="200"
        )
      v-flex(xs12)
      v-flex(xs2)
      v-flex(xs3)
        v-card(v-on:click="open_new")
          v-img(:src="require('@/assets/new.svg')"
           class="my-3" contain height="160")
          v-card-text
            h1 新規売上伝票
      v-flex(xs3)
        v-card(v-on:click="open_list")
          v-img(:src="require('@/assets/new.svg')"
           class="my-3" contain height="160")
          v-card-text
            h1 売上伝票一覧
      v-flex(xs3)
        v-card(v-on:click="open_customers")
          v-img(:src="require('@/assets/new.svg')"
           class="my-3" contain height="160")
          v-card-text
            h1 お得意先一覧
      v-flex(xs2)
      v-flex(xs1)
      v-flex(xs3)
        v-card(v-on:click="open_bank_accounts")
          v-img(:src="require('@/assets/new.svg')"
           class="my-3" contain height="160")
          v-card-text
            h1 銀行口座一覧
      v-flex(xs3)
        v-card(v-on:click="open_list")
          v-img(:src="require('@/assets/new.svg')"
           class="my-3" contain height="160")
          v-card-text
            h1 敬称一覧
</template>

<script>
  export default {
    name: 'sales_slipMenu',
    methods: {
      open_new() { this.$router.push('/sales_slip/new')},
      open_list() { this.$router.push('/sales_slip/list')},
      open_customers() { this.$router.push('/customers/list')},
      open_bank_accounts() { this.$router.push('/bank_accounts/list')},
    }
  }
</script>
